import { render, staticRenderFns } from "./MyExam.vue?vue&type=template&id=10bb7ae3"
import script from "./MyExam.vue?vue&type=script&lang=js"
export * from "./MyExam.vue?vue&type=script&lang=js"
import style0 from "./MyExam.vue?vue&type=style&index=0&id=10bb7ae3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports